<template>
  <div>
    <qx-card title="维保申请" class="detail" v-loading="loading">
      <!-- 订单详情数据 -->
      <qx-detail-box
        v-for="(data, index) in detailData"
        :data="data"
        :key="index"
      >
        <img slot="img" src="/" />
      </qx-detail-box>
      <!-- 订单详情数据 end -->
    </qx-card>
    <ApproveBox
      v-if="(type ||$route.query.type) === 'approve'"
      :busiId="id ? String(id) : $route.query.id"
      busiCode="22000048"
      :inFast="Boolean(id)"
    />
  </div>
</template>

<script>
import {
  maintenanceDetail, // 获取详情
} from 'api/cost';
import ApproveBox from 'components/approveBox';
export default {
  components: {
    ApproveBox,
  },
  props: {
    id: {
      type: Number,
    },
    type: {
      type: String,
    },
  },
  data () {
    return {
      loading: false,
      detailData: {
        base: {
          label: '维保申请',
          tableData: {
            title: [
              {
                prop: 'applyUserName',
                label: '申请人',
              },
              {
                prop: 'updateTime',
                label: '申请时间',
              },
              {
                prop: 'applyCode',
                label: '申请单号',
              },
              {
                prop: 'applyTypeName',
                label: '费用类型',
              },
              {
                prop: 'orgName',
                label: '费用归属',
              },
              {
                prop: 'preAmt',
                label: '预估费用',
              },
              {
                prop: 'plateNumber',
                label: '车牌号码',
              },
              {
                prop: 'licenceTypeName',
                label: '牌照类型',
              },
              {
                prop: 'orgName',
                label: '归属部门',
              },
              {
                prop: 'userName',
                label: '司机姓名',
              },
              {
                prop: 'mobilePhone',
                label: '司机手机',
              },
              {
                prop: 'orderId',
                label: '订单号码',
              },
              {
                prop: 'serviceName',
                label: '服务商',
              },
              {
                prop: 'productName',
                label: '维修站点',
              },
              {
                prop: 'feeAscriptionDate',
                label: '费用归属日期',
              },
              // {
              //   prop: 'address',
              //   label: '上传图片',
              //   slot: 'img',
              // },
              {
                prop: 'repairReson',
                label: '申请原因',
              },
              {
                prop: 'amtRemark',
                label: '费用说明',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
      },
    };
  },
  computed: {
    colSpan () {
      const total = 24;
      const minSpan = 4;
      return parseInt(total / this.orderInfo.length, 10) < minSpan ? minSpan : parseInt(total / this.orderInfo.length, 10);
    },
  },
  watch: {
    '$route.query.id': function () {
      this.getData();
    },
  },
  methods: {
    async getData () {
      if (this.$route.path !== '/manage/cost/car/apply/maintenanceDetail' && !this.id) {
        return;
      }
      this.loading = true;
      const detailRes = await maintenanceDetail({
        applyId: this.id || this.$route.query.id,
        isEdit: 2,
      });
      this.loading = false;
      if (!detailRes.failed) {
        detailRes.costDetails[0].beforePicList.forEach((item, index) => {
          this.detailData.base.tableData.title.push({
            label: `上传图片${index + 1}`,
            prop: `pic${index + 1}`,
            type: 'img',
          });
          detailRes[`pic${index + 1}`] = item.fileUrl;
        });
        // if (this.$route.query.type) {
        //   this.detailData.base.tableData.approveData = detailRes.ver;
        // }
        this.detailData.base.tableData.data = {
          ...detailRes,
          ...detailRes.costDetails[0],
        };
      }
    },
  },
  created () {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import "styles/config.scss";
.orderStatusBox{
  overflow: auto;
}
.orderInfoBox{
  margin: 16px 12px 0;
  min-height: 124px;
  border: 1px solid $border-color;
  padding: 24px 16px;
  box-sizing: border-box;
  .title{
    font-size: 16px;
    height: 16px;
    line-height: 16px;
    padding-bottom: 16px;
  }
  .desc,.time{
    color: #666;
    line-height: 16px;
  }
  .desc{
    padding-bottom: 12px;
  }
}
.box{
  border-top: 1px solid $border-color;
  border-left: 1px solid $border-color;
  border-right: 1px solid $border-color;
}
.itemLabel{
  background: $grey;
}
.itemLabel,.itemText{
  height: 48px;
  line-height: 48px;
  padding: 0 24px;
  box-sizing: border-box;
  border-bottom: 1px solid $border-color;
}
</style>
